/**
 * Portal Manta · Card3KPIs
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { M, F, STATUS } from '../../tokens/theme.js';
import { extKm } from '../../globals.js';

const Card3KPIs = memo(function Card3KPIs_Inner({kpis, setK}){
  const inputStl = {width:'100%', padding:'7px 10px', border:`1px solid ${M.border}`, borderRadius:4, fontFamily:F.mono, fontSize:11.5, color:M.text, outline:'none', background:'#fff'};
  const labelStl = {fontSize:9.5, fontWeight:700, color:M.muted, letterSpacing:.5, marginBottom:5, textTransform:'uppercase'};
  const cmps = [
    {k:'extKm',  l:'Extensão total (km)*',  hint:'campo obrigatório · base de tudo'},
    {k:'dupKm',  l:'Duplicações (km)',      hint:'pista nova ao lado da existente'},
    {k:'margKm', l:'Marginais (km)',        hint:'em zonas urbanas / acessos'},
    {k:'fxKm',   l:'Faixas adicionais (km)',hint:'3ª faixa de subida, etc'},
    {k:'ciclKm', l:'Ciclovias (km)',        hint:'separadas da pista'},
    {k:'oaeQt',  l:'OAEs (un)',             hint:'pontes + viadutos + túneis'},
    {k:'passQt', l:'Passarelas (un)',       hint:'travessias de pedestre'},
    {k:'interQt',l:'Interseções (un)',      hint:'diamantes + trombetas + parclos + rotatórias'},
  ];

  return (<div>
    <div style={{fontSize:11.5, color:M.muted, marginBottom:14}}>
      Quantidades físicas das obras. Se você importou no card 2, os valores estão preenchidos · ajuste se necessário.
    </div>
    <div style={{display:'grid', gridTemplateColumns:'repeat(4, 1fr)', gap:12, marginBottom:14}}>
      {cmps.map(c => (
        <div key={c.k}>
          <div style={labelStl}>{c.l}</div>
          <input type="number" value={kpis[c.k]} onChange={e=>setK(c.k, parseFloat(e.target.value)||0)} style={inputStl}/>
          <div style={{fontSize:9, color:M.light, marginTop:3, fontStyle:'italic', lineHeight:1.3}}>{c.hint}</div>
        </div>
      ))}
    </div>
    {/* KPIs derivados (densidades) */}
    {kpis.extKm > 0 && (<div style={{padding:'10px 14px', background:M.bgAlt, borderRadius:5, border:`1px solid ${M.borderSoft}`, marginTop:8}}>
      <div style={{fontSize:9.5, fontWeight:700, color:M.muted, letterSpacing:.5, textTransform:'uppercase', marginBottom:8}}>Densidades calculadas</div>
      <div style={{display:'grid', gridTemplateColumns:'repeat(5, 1fr)', gap:14, fontSize:10.5}}>
        <div><span style={{color:M.muted}}>Dup/ext:</span> <b style={{fontFamily:F.mono, color:M.heading}}>{(kpis.dupKm/kpis.extKm*100).toFixed(1)}%</b></div>
        <div><span style={{color:M.muted}}>Marg/ext:</span> <b style={{fontFamily:F.mono, color:M.heading}}>{(kpis.margKm/kpis.extKm*100).toFixed(1)}%</b></div>
        <div><span style={{color:M.muted}}>OAE/km:</span> <b style={{fontFamily:F.mono, color:M.heading}}>{(kpis.oaeQt/kpis.extKm).toFixed(2)}</b></div>
        <div><span style={{color:M.muted}}>Inter/km:</span> <b style={{fontFamily:F.mono, color:M.heading}}>{(kpis.interQt/kpis.extKm).toFixed(2)}</b></div>
        <div><span style={{color:M.muted}}>Cicl/ext:</span> <b style={{fontFamily:F.mono, color:M.heading}}>{(kpis.ciclKm/kpis.extKm*100).toFixed(1)}%</b></div>
      </div>
    </div>)}
  </div>);
});

export { Card3KPIs };
export default Card3KPIs;
